import React from "react";
import { Box, Typography } from "@mui/material";
import "./ProgressCircle.css"

const ProgressCircle = ({ value = 55, size = 180, stroke = 20 }) => {
    const radius = (size - stroke) / 2;
    const circumference = 2 * Math.PI * radius;
    const progress = (value / 100) * circumference;

    return (
        <Box position="relative" width={size} height={size} sx={{margin: "auto"}}>
            <svg width={size} height={size}>
                {/* Background circle */}
                <circle cx={size / 2} cy={size / 2} r={radius} stroke="#e0e0e0" strokeWidth={stroke} fill="none" />

                {/* Progress circle */}
                <circle cx={size / 2} cy={size / 2} r={radius} stroke="url(#gradient)" strokeWidth={stroke} fill="none" strokeDasharray={circumference} strokeDashoffset={circumference - progress} strokeLinecap="round" transform={`rotate(-90 ${size / 2} ${size / 2})`} />

                {/* Gradient */}
                <defs>
                    <linearGradient id="gradient">
                        <stop offset="0%" stopColor="var(--main)" />
                        <stop offset="50%" stopColor="var(--purple)" />
                    </linearGradient>
                </defs>
            </svg>

            {/* Center text */}
            <Box position="absolute" top="50%" left="50%" sx={{ transform: "translate(-50%, -50%)" }}   >
                <Typography variant="h6" className={"progress-circle-label"}>{value}%</Typography>
            </Box>
        </Box>
    );
};

export default ProgressCircle;